<template>
  <div class="main">
    <el-container class="main-box">
        <!-- 顶栏 -->
        <el-header id="header" style="height:auto;" >
            <YHeaderPhone class="headerc"></YHeaderPhone>
        </el-header>
        <!-- 内容区域 -->
        <el-main class="container">
           <router-view></router-view>
        </el-main>
        <!-- 底栏 -->
        <el-footer class="floorfooter" style="">
             <YFooterPhone class="footerc"></YFooterPhone> 
        </el-footer>
    </el-container>
  </div>
</template>

<script>
//引入外部组件
import {YHeaderPhone,YFooterPhone} from '@/components'
export default {
    name:'YedeerLayoutPhone',
    components:{YHeaderPhone,YFooterPhone},
}
</script>

<style lang="less" scoped>
    .main{
        min-height: 100vh;
        height: 100vh;
        width: 100vw;
        margin: 0 auto;
        position: relative;
    }
    .main-box{
        position: relative;
    }

    .container{
        // width: 100%;
        margin: 0 auto;

    }
    #header{
        position: absolute;
        min-height: 1.38rem;
        width:100vw;
        box-sizing: border-box;
    }
    .headerc{
        position: absolute;
        top: 1rem;
        width:100vw;
        box-sizing: border-box;

    }
    .floorfooter{
        // position: absolute;
        // bottom: 0rem;
        width: 100vw;
        // min-height: 2rem;
        padding-bottom: 2rem;
        height: auto;
        .footerc{
            position: absolute;
            width: 100vw;
            // background-color: pink;
        }
    }
    /deep/ .el-header{
        padding: 0;
    }
    /deep/ .el-footer{
        padding: 0;
    }
    /deep/ .el-main{
        padding: 0;
    }
</style>